export const limitedReleaseByRegionConstants = {
  LIMITED_RELEASE_BY_REGION_LOADING: "LIMITED_RELEASE_BY_REGION_LOADING",
  LIMITED_RELEASE_BY_REGION_SUCCESS: "LIMITED_RELEASE_BY_REGION_SUCCESS",
  LIMITED_RELEASE_BY_REGION_FAILURE: "LIMITED_RELEASE_BY_REGION_FAILURE",
};

export const createLimitedReleaseByRegionConstants = {
  CREATE_LIMITED_RELEASE_BY_REGION_LOADING:
    "CREATE_LIMITED_RELEASE_BY_REGION_LOADING",
  CREATE_LIMITED_RELEASE_BY_REGION_SUCCESS:
    "CREATE_LIMITED_RELEASE_BY_REGION_SUCCESS",
  CREATE_LIMITED_RELEASE_BY_REGION_FAILURE:
    "CREATE_LIMITED_RELEASE_BY_REGION_FAILURE",
};

export const editLimitedReleaseByRegionConstants = {
  EDIT_LIMITED_RELEASE_BY_REGION_LOADING:
    "EDIT_LIMITED_RELEASE_BY_REGION_LOADING",
  EDIT_LIMITED_RELEASE_BY_REGION_SUCCESS:
    "EDIT_LIMITED_RELEASE_BY_REGION_SUCCESS",
  EDIT_LIMITED_RELEASE_BY_REGION_FAILURE:
    "EDIT_LIMITED_RELEASE_BY_REGION_FAILURE",
};

export const deleteLimitedReleaseByRegionConstants = {
  DELETE_LIMITED_RELEASE_BY_REGION_LOADING:
    "DELETE_LIMITED_RELEASE_BY_REGION_LOADING",
  DELETE_LIMITED_RELEASE_BY_REGION_SUCCESS:
    "DELETE_LIMITED_RELEASE_BY_REGION_SUCCESS",
  DELETE_LIMITED_RELEASE_BY_REGION_FAILURE:
    "DELETE_LIMITED_RELEASE_BY_REGION_FAILURE",
};

export const addTargetLimitedReleaseByRegionConstants = {
  ADD_TARGET_LIMITED_RELEASE_BY_REGION_LOADING:
    "ADD_TARGET_LIMITED_RELEASE_BY_REGION_LOADING",
  ADD_TARGET_LIMITED_RELEASE_BY_REGION_SUCCESS:
    "ADD_TARGET_LIMITED_RELEASE_BY_REGION_SUCCESS",
  ADD_TARGET_LIMITED_RELEASE_BY_REGION_FAILURE:
    "ADD_TARGET_LIMITED_RELEASE_BY_REGION_FAILURE",
};

export const removeTargetLimitedReleaseByRegionConstants = {
  REMOVE_TARGET_LIMITED_RELEASE_BY_REGION_LOADING:
    "REMOVE_TARGET_LIMITED_RELEASE_BY_REGION_LOADING",
  REMOVE_TARGET_LIMITED_RELEASE_BY_REGION_SUCCESS:
    "REMOVE_TARGET_LIMITED_RELEASE_BY_REGION_SUCCESS",
  REMOVE_TARGET_LIMITED_RELEASE_BY_REGION_FAILURE:
    "REMOVE_TARGET_LIMITED_RELEASE_BY_REGION_FAILURE",
};

export const activateLimitedReleaseByRegionConstants = {
  ACTIVATE_LIMITED_RELEASE_BY_REGION_LOADING:
    "ACTIVATE_LIMITED_RELEASE_BY_REGION_LOADING",
  ACTIVATE_LIMITED_RELEASE_BY_REGION_SUCCESS:
    "ACTIVATE_LIMITED_RELEASE_BY_REGION_SUCCESS",
  ACTIVATE_LIMITED_RELEASE_BY_REGION_FAILURE:
    "ACTIVATE_LIMITED_RELEASE_BY_REGION_FAILURE",
};

export const deactivateLimitedReleaseByRegionConstants = {
  DEACTIVATE_LIMITED_RELEASE_BY_REGION_LOADING:
    "DEACTIVATE_LIMITED_RELEASE_BY_REGION_LOADING",
  DEACTIVATE_LIMITED_RELEASE_BY_REGION_SUCCESS:
    "DEACTIVATE_LIMITED_RELEASE_BY_REGION_SUCCESS",
  DEACTIVATE_LIMITED_RELEASE_BY_REGION_FAILURE:
    "DEACTIVATE_LIMITED_RELEASE_BY_REGION_FAILURE",
};
